import { actionGenerator } from '../../utils/redux/actionGenerator';
import { chartsActionTypes } from '../../constants/actionTypes/charts';
import { ITypedReduxAction } from '../../types/redux/actionType';

export const setLoading = actionGenerator<chartsActionTypes.SET_LOADING, boolean>(chartsActionTypes.SET_LOADING);

export type TSetLoadingAction = ITypedReduxAction<chartsActionTypes.SET_LOADING, boolean>;

export type TChartsActions = TSetLoadingAction;
